import React from 'react';
export function PainSection() {
  return <section className="py-6 px-4 bg-white border-t border-gray-100" data-id="element-87" data-mp="1rs43zm8c0j9k">
      <div className="max-w-3xl mx-auto text-center md:text-left" data-id="element-88" data-mp="38wvlym7az9q2">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E]" data-id="element-89" data-mp="2uyfdoqtslb5t">
          Si sos docente, dejame hacerte una pregunta honesta:
        </h2>

        <p className="text-xl md:text-2xl font-bold text-red-600 mb-3 text-center" data-id="element-90" data-mp="2yxxo2snzm3ue">
          ¿Sentís que pasás horas adaptando actividades porque los materiales
          tradicionales no funcionan para todos?
        </p>

        <div className="text-lg text-gray-700 space-y-2 mb-4" data-id="element-91" data-mp="2q0vsf6yofy4d">
          <p data-id="element-92" data-mp="2bbr5xdkun7qg"></p>
          <p data-id="element-93" data-mp="2b83bmc7kyhao"></p>
          <p className="font-bold" data-id="element-94" data-mp="2b8bsef6tq6r5">
            <span className="px-1 bg-[#FFFFFF]" data-id="element-95" data-mp="2g8hny6g7sdei">
              Es porque los materiales suelen ser saturados, visualmente
              caóticos, difíciles de comprender y excesivos para algunos
              alumnos.
            </span>
          </p>
        </div>

        <p className="text-lg text-gray-700 font-medium" data-id="element-96" data-mp="3rn0t9io8aq64">
          Y entre planificaciones, clases y reuniones terminás dedicando horas a
          intentar hacer el material más accesible para que todos puedan
          participar.
        </p>

        <p className="text-xl font-bold text-center mt-4 text-gray-900" data-id="element-97" data-mp="5ere0f8142ty">
          La inclusión educativa no debería significar trabajar el triple.
        </p>
      </div>
    </section>;
}